module.exports = __webpack_public_path__ + "img/manImg.7bf8c040.png";